<template>
  <div>
    <h2 class="section-title m-4 text-center text-lg">おしらせ</h2>
    <div v-if="message" class="p-4 border-b border-section_border bg-white">
      <h3 class="font-bold text-link_darker">{{ message.title }}</h3>          
      <p class="text-current">{{ getMoment(message.dispDate) }}</p>
      <p class="py-3 message_detail" v-html="message.detail.replace(/\n/g, '<br />')" />
    </div>
    <div class="mt-4">
      <button @click="backNotice" class="button-secondary block w-full">
        <div class="h-full flex items-center focus:outline-none">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
        <span class="w-full -ml-5">一覧へ戻る</span></div></button>
    </div>
  </div> 
</template>
  
  <script>
  import moment from "moment";
  
  export default {
    name: 'NoticeDetail',
    props: {
      message: {
        type: Object,
        required: false
      }
    },
    methods: {
      backNotice: function () {
        //詳細表示
        this.$emit('backNotice')
      },
      getMoment: function (date) {
        return moment(date).format('YYYY/MM/DD')
      }

    }
}
  </script>